import styled from 'styled-components';
import { TCustomComponentProps } from '../Markdown.types';

const StyledUnorderedList = styled.ul`
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  list-style: disc !important; // prevents reset.css from overriding this value to 'none'

  padding-left: ${({ theme }) => theme.spacing['xl']};
  margin-left: ${({ theme }) => theme.spacing['sm']};
`;

export const CustomUnorderedList = ({ children }: TCustomComponentProps<HTMLUListElement>) => {
  return <StyledUnorderedList>{children}</StyledUnorderedList>;
};
